import { useEffect, useState } from 'react';

const COARSE = '(pointer: coarse)';

// True on a touch screen. A tablet that gets a mouse plugged in switches while the screen is open.
const useCoarsePointer = () => {
  const [coarse, setCoarse] = useState(() => window.matchMedia?.(COARSE).matches ?? false);

  useEffect(() => {
    const media = window.matchMedia?.(COARSE);
    if (!media) return;

    const onChange = () => setCoarse(media.matches);
    onChange();
    media.addEventListener('change', onChange);

    return () => media.removeEventListener('change', onChange);
  }, []);

  return coarse;
};

export default useCoarsePointer;
